import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { installPageTitle } from './lib/pageTitle';

// routeTree is generated by @tanstack/router-plugin (vite.config.js) from
// src/routes/** — see __root.tsx (shell) and $.tsx (legacy switch, shrinking
// as modules migrate to real file routes).
export const router = createRouter({
  routeTree,
  defaultNotFoundComponent: () => null,
});

// The tab's name follows the URL from here on — every route, no page's involvement.
installPageTitle(router);

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
